import { createSafeJotaiSessionStorage } from '@/lib/jotai-storage';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';
import { atomWithStorage } from 'jotai/utils';

/**
 * Placeholder booking URL handed to the CTA when the dev override is on. Not a
 * real per-market link — it only exists so the sidebar footer button has a
 * non-null `href` to render and click through.
 */
export const DISCOVERY_CALL_DEV_STUB_URL =
  'https://www.heidihealth.com/?devToolsStub=discovery-call';

/**
 * Force-shows only the sidebar footer "Book a discovery call" CTA, bypassing the
 * market gate (the user's resolved country plus the PostHog `country-config`
 * payload). Non-production only; ignored in prod.
 *
 * Session-scoped rather than persistent: it's a QA affordance, so a forgotten
 * `true` shouldn't follow the tester across sessions. Closing the tab clears it.
 */
export const discoveryCallDevForceShowAtom = atomWithStorage<boolean>(
  'heidi.devTools.discoveryCall.forceShow',
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

discoveryCallDevForceShowAtom.debugLabel = 'discoveryCallDevForceShowAtom';

export const isDiscoveryCallDevOverridesEnabled = (): boolean =>
  getEnvironment() !== ENV_NAME.PROD;
